import { useGetRxDb } from '@hooks/getRxdbData';
import { ProfileData } from '@services/hooks/profile';

export const useUserRoleType = (): string => {
	const { result: profile } = useGetRxDb<ProfileData>('profile');
	return profile?.[0]?.usertype_c ?? '';
};
